import { useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { useProductDataStore, useProductInfoStore } from '../store';
import { getPromoEligibleProducts } from '../utils/promo-utils';

const seedDimensionsAsync = (
  experienceProductData, configurator,
  initializeSkuDimensions, trackPageLoadWithProductImpressionsEvent,
  store, productInfo
) => {
  const skuDimensions = {};
  const items = Object.keys(experienceProductData).map((item) => {
    const dimensions = experienceProductData[item]?.specificationGroup
      ?.filter((dim) => dim.specTitle === 'Dimensions')?.[0]?.specifications;
    let width = 0; let height = 0; let
      depth = 0;
    if (dimensions) {
      // eslint-disable-next-line no-restricted-syntax
      for (const spec of dimensions) {
        if (spec.specName === 'Product Width (in.)') {
          width = Number.parseFloat(spec.specValue);
        } else if (spec.specName === 'Product Height (in.)') {
          height = Number.parseFloat(spec.specValue);
        } else if (spec.specName === 'Product Depth (in.)') {
          depth = Number.parseFloat(spec.specValue);
        }
      }
    }
    const choice = Object.values(configurator.metadata).find(({ metadata }) => metadata.Sku === item)
      ?? { metadata: {
        SpecWidth: 0, SpecHeight: 0, SpecDepth: 0
      } };

    const { metadata: { SpecWidth = 0, SpecHeight = 0, SpecDepth = 0 } } = choice;

    skuDimensions[item] = {
      width: width || Number(SpecWidth),
      height: height || Number(SpecHeight),
      depth: depth || Number(SpecDepth),
    };
    return item;
  });

  if (Object.keys(skuDimensions).length > 0) {
    initializeSkuDimensions(skuDimensions);
  }
  if (items.length > 0) {
    if (trackPageLoadWithProductImpressionsEvent) {
      trackPageLoadWithProductImpressionsEvent(experienceProductData, store, configurator, productInfo);
    }
  }
};

export const useExtractDimensions = (
  experienceProductData,
  updateProductData,
  updateAllPromoProducts,
  initializeSkuDimensions,
  trackPageLoadWithProductImpressionsEvent,
  store,
  configurator
) => {
  const updateFetchedSkus = useProductDataStore((state) => state.updateFetchedSkus);
  const { productInfo } = useProductInfoStore((state) => state);

  useEffect(() => {
    if (_isEmpty(experienceProductData)) {
      return () => false;
    }
    const productData = { ...experienceProductData };
    const promoEligibleProducts = getPromoEligibleProducts(productData);
    updateProductData({ productData });
    updateAllPromoProducts({ ...promoEligibleProducts });
    updateFetchedSkus(Object.keys(productData));

    seedDimensionsAsync(
      experienceProductData, configurator, initializeSkuDimensions,
      trackPageLoadWithProductImpressionsEvent, store, productInfo,
    );

    return () => false;
  }, [experienceProductData, productInfo]);
};
